'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import { H3, P, SURFACE_REVEAL } from '@/components/ui';
import type { SpecialContentBlock } from '@/components/pages/marketing/special/types';

export type MarketingSeoContentSectionProps = {
  title: string;
  subtitle?: string;
  sections: readonly SpecialContentBlock[];
  className?: string;
  headingId?: string;
};

/**
 * Long-form SEO copy — stacked prose blocks in glass panels for crawlers and buyers.
 */
export default function MarketingSeoContentSection({
  title,
  subtitle,
  sections,
  className,
  headingId = 'marketing-seo-content',
}: MarketingSeoContentSectionProps) {
  if (!sections.length) return null;

  return (
    <section className={clsx('container-section page-seo-content', className)} aria-labelledby={headingId}>
      <div className="page-heading-wrap" id={headingId}>
        <Heading2
          title={title}
          subtitle={subtitle}
          titleClassName="text-prose"
          subtitleClassName="mt-3 text-prose-muted"
        />
      </div>
      <div className="page-content-grid page-grid-2">
        {sections.map((block) => (
          <article key={block.title} className={clsx('page-glass-panel page-glass-panel--elevated text-start', SURFACE_REVEAL)}>
            <H3 className="m-0 text-lg font-semibold text-prose">{block.title}</H3>
            <P className="m-0 mt-3 text-sm leading-relaxed text-prose-muted md:text-base">{block.body}</P>
          </article>
        ))}
      </div>
    </section>
  );
}
